export const EventList = (state) => {
    return state?.event?.events
};

export const EventIsLoading = (state) => {
    return state?.event?.showLoading;
};
